import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

interface ESIMDevice {
  id: string;
  brand: string;
  model_name: string;
  is_supported: boolean;
  notes: string | null;
}

interface DeviceBrand {
  name: string;
  models: { name: string; supported: boolean; notes?: string }[];
}

export function useESIMDevices() {
  const [deviceData, setDeviceData] = useState<DeviceBrand[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchDevices();
  }, []);

  const fetchDevices = async () => {
    const { data, error } = await supabase
      .from('esim_devices')
      .select('*')
      .order('brand')
      .order('sort_order')
      .order('model_name');

    if (error || !data || data.length === 0) {
      // Return empty if no data in database
      setDeviceData([]);
      setLoading(false);
      return;
    }

    // Group devices by brand
    const brandMap = new Map<string, { name: string; supported: boolean; notes?: string }[]>();
    
    data.forEach((device: ESIMDevice) => {
      if (!brandMap.has(device.brand)) {
        brandMap.set(device.brand, []);
      }
      brandMap.get(device.brand)!.push({
        name: device.model_name,
        supported: device.is_supported,
        notes: device.notes || undefined
      });
    });

    const formatted: DeviceBrand[] = Array.from(brandMap.entries()).map(([name, models]) => ({
      name,
      models
    }));

    setDeviceData(formatted);
    setLoading(false);
  };

  return { deviceData, loading, refetch: fetchDevices };
}
